import React, {
  createRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';

import { StyledMenuItemList } from './MenuItemList.styles';

import { menuDefaultProps } from '../Menu.defaultProps';
import { MenuItemListProps } from './MenuItemList.types';
import { MenuItem, MenuItemProps } from '../MenuItem';

const MenuItemList = forwardRef(
  (
    {
      itemList,
      display,
      depth = 0,
      componentClassname = 'menu-item-list',
      customClassnames = '',
      beforeMenuItemListSlot,
      afterMenuItemListSlot,
      renderLink,
      currentLocationPath,
      wayToDisplayChildrenByDropdown = menuDefaultProps.wayToDisplayChildrenByDropdown,
      areChildrenDisplayedByDropdown = menuDefaultProps.areChildrenDisplayedByDropdown,
      toggleSlot = menuDefaultProps.toggleSlot,
      currentPageLabel = menuDefaultProps.currentPageLabel,
      onOpenSubMenu = menuDefaultProps.onOpenSubMenu,
      onCloseSubMenu = menuDefaultProps.onCloseSubMenu,
    }: MenuItemListProps,
    ref,
  ) => {
    const [elRefs, setElRefs] = useState([]);

    useEffect(() => {
      setElRefs((elRefs) =>
        Array(itemList.length)
          .fill(null)
          .map((_, i) => elRefs[i] || createRef()),
      );
    }, []);

    useImperativeHandle(ref, () => ({
      closeSubMenu() {
        elRefs.forEach((menuItem) => {
          menuItem.current.closeSubMenu();
        });
      },
    }));

    return (
      <StyledMenuItemList
        className={`${componentClassname} ${customClassnames}`}
      >
        {beforeMenuItemListSlot && (
          <span className={`${componentClassname}__before-content`}>
            {beforeMenuItemListSlot}
          </span>
        )}
        <ul className={`${componentClassname}__item-list`} data-depth={depth}>
          {itemList.map((menuItem: MenuItemProps, index) => (
            <MenuItem
              ref={elRefs[index]}
              key={index}
              {...menuItem}
              itemTag="li"
              customClassnames={`${componentClassname}__item ${
                menuItem.customClassnames ? menuItem.customClassnames : ''
              }`}
              display={display}
              depth={depth}
              renderLink={renderLink}
              currentLocationPath={currentLocationPath}
              wayToDisplayChildrenByDropdown={
                menuItem.wayToDisplayChildrenByDropdown ??
                wayToDisplayChildrenByDropdown
              }
              areChildrenDisplayedByDropdown={
                menuItem.areChildrenDisplayedByDropdown ??
                areChildrenDisplayedByDropdown
              }
              currentPageLabel={menuItem.currentPageLabel ?? currentPageLabel}
              toggleSlot={menuItem.toggleSlot ?? toggleSlot}
              onOpenSubMenu={menuItem.onOpenSubMenu ?? onOpenSubMenu}
              onCloseSubMenu={menuItem.onCloseSubMenu ?? onCloseSubMenu}
            />
          ))}
        </ul>
        {afterMenuItemListSlot && (
          <span className={`${componentClassname}__after-content`}>
            {afterMenuItemListSlot}
          </span>
        )}
      </StyledMenuItemList>
    );
  },
);
MenuItemList.displayName = 'MenuItemList';

export default MenuItemList;
